// 📦 Import de React
import React, { useState } from "react";
// 🎨 Import de composants Material-UI pour la mise en page
import { FormControl, InputLabel, Select, MenuItem, Box } from "@mui/material";

// 📊 Import du composant DataGrid de MUI pour afficher un tableau interactif
import { DataGrid, useGridApiRef } from "@mui/x-data-grid";
import { Tooltip } from "@mui/material";
import { TextField } from "@mui/material";
import { mapMoment, getMomentColor } from "../../constants/moments.js";
import { logDev } from "../../utils/logger.js";

// 📤 Boutons d’action personnalisés
import PrintButton from "../BoutonPrint.js";
import BoutonEmailPeriodeDominante from "../BoutonEmailPeriodeDominante.js";
import BoutonEnvoyerLienPageList from "../../components/BoutonEnvoyerLienPageList.js";
import BoutonEnvoyerSMSParticipantsListe from "../../components/BoutonEnvoyerSMSParticipantsListe.js";
import { ALL_CATEGORIES, makeCategoryLabels } from "../../constants/categories";

/**
 * Composant d'affichage du tableau des items de liste.
 * @param {number} headerHeight - Hauteur de l'en-tête pour ajuster la marge haute
 * @param {boolean} isMobile - Indique si l'affichage est sur mobile
 * @param {Array} rows - Lignes du tableau
 * @param {Array} columns - Colonnes du tableau
 * @param {Array} filteredContacts - Liste des contacts filtrés
 * @param {Array} visibleContactIds - IDs des contacts dont les colonnes sont visibles
 * @param {Function} setVisibleContactIds - Setter pour mettre à jour les contacts visibles
 * @param {Function} processRowUpdate - Fonction pour gérer la mise à jour d'une ligne
 * @param {Function} getRowClassName - Fonction pour appliquer des classes CSS aux lignes
 * @param {Array} emailsPeriodeDominante - Emails liés à la période dominante
 * @param {string} nomGroupe - Nom du groupe
 * @param {Function} t - Fonction de traduction
 * @param {Function} onPrint - Fonction pour imprimer
 */

const TableauListeItems = ({
  headerHeight,
  isMobile,
  rows,
  columns,
  filteredContacts = [],   // ✅ valeur par défaut
  visibleContactIds,
  setVisibleContactIds,
  processRowUpdate,
  getRowClassName,
  emailsPeriodeDominante,
  nomGroupe,
  t,
  isAdmin,
  bottomNavHeight,
  emojiGroupe,
  couleurGroupe,
  groupeId,         
  snackbar,         
  setSnackbar,       
  transmissionActive,
  categorieFiltre,
  setCategorieFiltre

  }) => {
    
    const apiRef = useGridApiRef();
    logDev("🎨 Rows reçues dans TableauListeItems", rows);

    const [searchContact, setSearchContact] = useState("");
    const [emailManuel, setEmailManuel] = useState("");

    logDev("🧪 TableauListeItems t =", {
      type: typeof t,
      t
    });

  const safeT = typeof t === "function" ? t : (x) => x;
  const labels = makeCategoryLabels(safeT);

  const normalizedRows = Array.isArray(rows)
  ? rows.map(r => {
      const safeMoment = mapMoment(r.quoi?.moment);
      return {
        ...r,
        color: r.color || getMomentColor(safeMoment),
        quoi: {
          ...r.quoi,
          moment: safeMoment
        }
      };
    })
  : [];

  const rowsFiltres =
  categorieFiltre === "Tout"
    ? normalizedRows
    : normalizedRows.filter((r) => {
        const cat = r.quoi?.categorie || r.theme || "";
        return cat.toLowerCase().includes(categorieFiltre.toLowerCase());
      });

  const isValidEmail = (email) =>
  /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);

  const contactsFiltres = Array.isArray(filteredContacts)
    ? filteredContacts.filter(c =>
      c.nom.toLowerCase().includes(searchContact.toLowerCase())
      )
    : [];


    logDev("✅ normalizedRows IDs détaillés", normalizedRows.map(r => ({
      _id: r._id,
      id: r.id,
      nom: r.nom
    }))
  );

  logDev("🧪 Conditions bouton", {
    isAdmin,
    transmissionActive,
    emailsPeriodeDominante
  });

  return (
    <div className="listeitems-container" style={{ width: "100%" }}>
      

        {Array.isArray(rows) && rows.length > 0 && (
        <Box sx={{ marginBottom: 2 }}>

 
          <Box sx={{ display: "flex", flexWrap: "wrap", gap: 2, marginTop: 1 }}>

            {contactsFiltres.map((contact) => {
              const isChecked = visibleContactIds.includes(String(contact._id));

              return (
                <label key={contact._id} style={{ display: "flex", alignItems: "center" }}>

                  <input

                  type="checkbox"
                  checked={isChecked}
                  onChange={(e) => {
                    if (e.target.checked) {
                      setVisibleContactIds((prev) => [...prev, String(contact._id)]);
                      } else {
                        setVisibleContactIds((prev) =>
                          prev.filter((id) => id !== String(contact._id))
                        );
                        }
                        }}

                />

                <span style={{ marginLeft: 6 }}>{contact.nom}</span>

                </label>
        );
      })}
    </Box>
  </Box>
)}

{/*{!isAdmin && (
  <Box
    sx={{
      mb: 4,
      p: 2,
      textAlign: "center",
      backgroundColor: "#2f2f2f",
      color: "#fff",
      borderRadius: 1,
      border: "2px solid #d4af37"
    }}
  >
    {t("EmptyListeUsersMsg")}
  </Box>
)}*/}

{/* selecteur catégorie */}
<Box sx={{ mt:3, mb: 2, display: "flex", justifyContent: "flex-start" }}>
  <FormControl size="small" sx={{ minWidth: 180 }}>
    <InputLabel>{t("Category")}</InputLabel>
    <Select
      value={categorieFiltre}
      label={t("Category")}
      onChange={(e) => setCategorieFiltre(e.target.value)}
    >
    
      <MenuItem value="Tout">{t("All")}</MenuItem>

      {ALL_CATEGORIES.map((cat) => (
        <MenuItem key={cat} value={cat}>
          {labels[cat] || cat}
        </MenuItem>
      ))}
    </Select>
  </FormControl>
</Box>

 
{/* 📊 Tableau interactif */}
  {Array.isArray(rows) && rows.length > 0 && (
    <DataGrid
      apiRef={apiRef}
      columns={columns}
      rows={rowsFiltres}
      pinnedColumns={{ left: ["quoi", "quantite", "pris"] }}
      getRowId={(row) => row.id || row._id}
      editMode="cell"
      processRowUpdate={processRowUpdate}
      onProcessRowUpdateError={(error) => {
        logDev("❌ Erreur processRowUpdate :", error); 
       }}           
      experimentalFeatures={{ newEditingApi: true }}
      disableSelectionOnClick   // ✅ évite la sélection “inutile” au 1er clic
      isCellEditable={(params) => !!params.colDef.editable} // ✅ active l’édition directe
      onCellClick={(params, event) => {

        const isEditable =
          typeof params.colDef.editable === "function"
            ? params.colDef.editable(params)
            : !!params.colDef.editable;

            if (!isEditable) return;
            // Vérifie si la cellule est déjà en édition
            const cellState = apiRef.current.getCellMode(params.id, params.field);
            if (cellState === "edit") return; // déjà en édition → on ne refait pas
              event.defaultMuiPrevented = true;
              requestAnimationFrame(() => {
              apiRef.current.startCellEditMode({
                id: params.id,
                field: params.field,
              });
            });
          }}

          getCellClassName={(params) => {
          // ✅ Colore uniquement la cellule "pris" si quantité atteinte
          if (params.field === "pris") {
            const pris = Number(params.value) || 0;
            const quantite = Number(params.row.quantite) || 0;
              if (pris >= quantite) {
                return "cell-green";
              }
            }
            return "";
          }}
          sx={{
            width: "100%",
            backgroundColor: "#e4dcd2",
            "& .MuiDataGrid-columnHeader": {
              position: "sticky",
              top: 0,
              backgroundColor: "#e4dcd2",
              zIndex: 1,
              fontWeight: "bold",
              color: "#343435"
            },   
            "& .MuiDataGrid-cell": {
              whiteSpace: "normal"
            },     
              
            // Style pour les cellules validées
            "& .cell-green": {
              backgroundColor: "#c8e6c9", // vert clair
              color: "#1b5e20",           // texte vert foncé
              fontWeight: "bold"
            },
            // 🔹 Supprime le fond sur l'icône/colonne triée
            "& .MuiDataGrid-columnHeader--sorted": {
              backgroundColor: "transparent !important"
            },
            "& .MuiDataGrid-sortIcon": {
              backgroundColor: "transparent !important"
            },                              
          }}
          initialState={{
            pagination: { paginationModel: { pageSize: 10, page: 0 } }
          }}
          getRowClassName={getRowClassName}
        />
      )}

      {/* 📤 Boutons d’action par contact */}
      {Array.isArray(rows) && rows.length > 0 && (
      <Box 
        sx={{ 
          marginTop: 3, 
          padding: 2,
          display: "flex",
          justifyContent: "center",
          flexWrap: "wrap", 
          gap: 2
          }}
          >
          {(visibleContactIds.length === 0
            ? (filteredContacts || [])
            : (filteredContacts || []).filter((contact) =>
                visibleContactIds.includes(String(contact._id))
              )
          ).map((contact) => (
            <Box
              key={contact._id}
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                gap: 2,
                marginBottom: 2
              }}
            >
              {/* Bouton d'impression */}
              <PrintButton 
              contact={contact} 
              rows={rows} 
              nomGroupe={nomGroupe}
              emojiGroupe={emojiGroupe}
              couleurGroupe={couleurGroupe}
              />
            </Box>
          ))}
        </Box>
        )}

        {isAdmin && transmissionActive && (
          <Box sx={{ 
            display: "flex", 
            flexDirection: "column", 
            alignItems: "center", 
            justifyContent: "center", 
            marginTop: 2 , 
            gap: 2
          }}>   

          <BoutonEnvoyerLienPageList
            groupeId={groupeId}
            destinataires={
              emailManuel?.trim()
                ? [emailManuel.trim()]
                : emailsPeriodeDominante
            }
            nomGroupe={nomGroupe}
            emojiGroupe={emojiGroupe}
            snackbar={snackbar}
            setSnackbar={setSnackbar}
            disabled={
              emailsPeriodeDominante.length === 0 &&
              !isValidEmail(emailManuel?.trim())
            }
          />
            
          {emailsPeriodeDominante.length === 0 && (
            <TextField
              label={t("EnterEmailManually")}
              variant="outlined"
              size="small"
              sx={{ mt: 1, width: "100%", maxWidth: 300 }}
              value={emailManuel}
              onChange={(e) => setEmailManuel(e.target.value)}
              placeholder="exemple@domaine.com, autre@domaine.fr"
              helperText={t("SeparateMultipleEmailsWithComma")}
              multiline
            />
          )}

          <BoutonEmailPeriodeDominante
            emails={emailsPeriodeDominante}
            nom={`${nomGroupe} - ${t("DominantPeriod")}`}
          />

          {isMobile && (
          <BoutonEnvoyerSMSParticipantsListe
            contacts={filteredContacts}
            nomGroupe={nomGroupe}
              />
          )}
                
        </Box> 
      )}       
    </div>    
  )};

export default TableauListeItems;
